import {
  vsServiceName as machineDetailTabsServiceName,
  MachineDetailTabsService,
  ITabConfig,
} from "./machineDetailTabsService";

export class MachineDetailTabsController {
  static $inject = [machineDetailTabsServiceName];
  constructor(
    private readonly machineDetailTabsService: MachineDetailTabsService
  ) {}

  getTabs(): ITabConfig[] {
    return this.machineDetailTabsService.getTabs();
  }
}
